import { useContext, useEffect, useRef } from "react";
import View from "views/logic/views/View";
import useView from "views/hooks/useView";
import useIsNew from "views/hooks/useIsNew";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import TelemetryContext from "logic/telemetry/TelemetryContext";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
const IlluminateDashboardViewTelemetry = () => {
  const view = useView();
  const isNew = useIsNew();
  const sendTelemetry = useSendTelemetry();
  const telemetryContext = useContext(TelemetryContext);
  const lastHandled = useRef(void 0);
  const isIlluminateDashboard = view.type === View.Type.Dashboard && view.scope === "ILLUMINATE";
  const viewId = view.id;
  const viewTitle = view.title;
  useEffect(() => {
    var _a, _b;
    if (((_a = lastHandled.current) == null ? void 0 : _a.viewId) === viewId && ((_b = lastHandled.current) == null ? void 0 : _b.telemetryContext) === telemetryContext) {
      return;
    }
    lastHandled.current = { viewId, telemetryContext };
    if (isIlluminateDashboard && !isNew) {
      sendTelemetry(TELEMETRY_EVENT_TYPE.DASHBOARD_ACTION.ILLUMINATE_DASHBOARD_VIEWED, {
        app_action_value: "illuminate-dashboard-view",
        event_details: { dashboard_title: viewTitle }
      });
    }
  }, [isIlluminateDashboard, isNew, sendTelemetry, telemetryContext, viewId, viewTitle]);
  return null;
};
export default IlluminateDashboardViewTelemetry;
